import React from 'react'
import styled from 'styled-components';
import Button  from '@material-ui/core/Button';

const Container = styled.div`

    width:100%;
    display:flex;
    flex-direction:column;
    align-items:center;
    color:#858585;
`

const SVGContainer = styled.div`
    padding-top:50px
`;

const TitleContainer = styled.div`
    padding-bottom:20px;
    font-size:23px;
    font-weight:500;
`;

const SubtitleContainer = styled.div`
    padding-bottom:40px;
    font-size:20px;
    font-weight:400;
`;

const ButtonContainer = styled.div`
    padding-top:10px;
`;


export default function ActionsNoAccessEmptyState({context}) {
    return (
        <Container>
            <SVGContainer>
                <img width="300px" src="../icons/Empty-State_lock.svg"/>
            </SVGContainer>
            <TitleContainer>
                You don't have rights to this application.
            </TitleContainer>
            <SubtitleContainer>
                Contact a ComplianceWorks administrator to request access.
            </SubtitleContainer>
            <ButtonContainer>
                <Button color="primary" variant="contained" href="mailto:complianceworks@bechtel.com">
                    Request Access
                </Button>
            </ButtonContainer>

        </Container>
    )
}
